<template>
  <div class="body">
    <h4>{{ $t("feedback.title") }}</h4>
    <p>{{ $t("feedback.infoMessage") }}</p>

    <el-form :model="form" :rules="rules" ref="form" @submit.native.prevent>
      <el-form-item prop="message">
        <el-input
          type="textarea"
          v-model="form.message"
          :rows="4"
          :placeholder="$t('feedback.form.message')"
        />
      </el-form-item>

      <el-form-item prop="email">
        <el-input
          type="search"
          v-model="form.email"
          :placeholder="$t('feedback.form.email')"
        />
      </el-form-item>

      <el-button type="primary" @click="submitForm">{{
        $t("feedback.form.submit")
      }}</el-button>
    </el-form>
  </div>
</template>

<script>
export default {
  props: {
    onSubmit: {
      type: Function,
      required: true
    }
  },
  data() {
    return {
      form: {
        email: "",
        message: ""
      },
      rules: {
        email: [
          {
            required: true,
            message: this.$t("feedback.errors.emailRequired"),
            trigger: "change"
          },
          {
            type: "email",
            message: this.$t("feedback.errors.emailWrongFormat"),
            trigger: "change"
          }
        ],
        message: [
          {
            required: true,
            message: this.$t("feedback.errors.messageRequired"),
            trigger: "change"
          }
        ]
      }
    };
  },
  methods: {
    submitForm() {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.onSubmit({
            email: this.form.email,
            message: this.form.message
          });
        } else {
          return false;
        }
      });
    }
  }
};
</script>

<style scoped>
.body {
  padding: 1rem;
}
</style>
